function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Получение массива боксов элементов саджеста
 * @param {Node} row
 * @return {Array<DOMRect>}
 */
export var getRowRects = function getRowRects(row) {
    if (!row) {
        return [];
    }

    var children = row.children;


    if (!children) {
        return [];
    }

    var length = children.length;

    var rects = [];

    for (var i = 0; i < length; i++) {
        rects.push(children[i].getBoundingClientRect());
    }

    return rects;
};

/**
 * Получить шаги слайдера
 * @param {Array<DOMRect>} rows
 * @param {DOMRect} containerRect
 * @param {Number} gap
 * @return {Array<Number>}
 */
export var getSteps = function getSteps(rows, containerRect) {
    var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var containerLeft = containerRect.left,
        containerWidth = containerRect.width;

    var items = rows.reduce(function (aux, row) {
        return [].concat(_toConsumableArray(aux), _toConsumableArray(row));
    }, []);
    var length = items.length;

    var steps = [0];

    items.sort(function (a, b) {
        return a.left > b.left ? 1 : -1;
    });

    var offset = 0;
    for (var i = 0; i < length; i++) {
        var rect = items[i];

        if (rect.right - containerLeft - offset > containerWidth) {
            offset = rect.left - containerLeft;
            steps.push(-offset + gap * 2);
        }
    }

    var stepsCount = steps.length;
    var singlePage = stepsCount === 1;

    if (!singlePage) {
        var maxRight = items[items.length - 1].right - containerLeft;
        steps[0] = gap;
        steps[stepsCount - 1] = -maxRight + containerWidth - gap;
    }

    return steps;
};

/**
 * Получить список слайдов находящихся в видимой области
 * @param {Array<Number>} params.steps
 * @param {Number} params.page
 * @param {Array<Number>} params.rowsRects
 * @param {Number} params.containerWidth
 * @param {Array<Number>} params.inViewport
 * @param {Number} params.gap
 * @return {Array<Number>}
 */
export var getInViewportSlides = function getInViewportSlides() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = params.steps,
        page = params.page,
        rowsRects = params.rowsRects,
        containerWidth = params.containerWidth,
        _params$gap = params.gap,
        gap = _params$gap === undefined ? 0 : _params$gap,
        _params$inViewport = params.inViewport,
        inViewport = _params$inViewport === undefined ? [] : _params$inViewport;

    var left = steps[page];

    return rowsRects.map(function (rect, index) {
        if (inViewport[index]) {
            return true;
        }

        if (!rect) {
            return false;
        }

        // За левой границей
        if (rect.right + left < -gap) {
            return false;
        }

        // За правой границей
        if (rect.left + left > containerWidth + gap) {
            return false;
        }

        return true;
    });
};